"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLibzipPromise = exports.getLibzipSync = void 0;
const makeInterface_1 = require("./makeInterface");
let mod = null;
function getLibzipSync() {
    if (mod === null)
        mod = makeInterface_1.makeInterface(require(`./libzipSync`));
    return mod;
}
exports.getLibzipSync = getLibzipSync;
async function getLibzipPromise() {
    return getLibzipSync();
}
exports.getLibzipPromise = getLibzipPromise;
